module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressFreight),
      expression: "progressFreight"
    }],
    staticClass: "freight-card"
  }, [(!_vm.$props.hideLink) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Freights',
        query: {
          search: _vm.freight.traking_number
        }
      }
    }
  }, [_vm._v("Перейти к грузу")]) : _vm._e(), _vm._v(" "), (_vm.freight && _vm.freight.full_price && _vm.freight.full_price.storage) ? _c('div', [_c('span', [_vm._v(_vm._s('Стоимость хранения груза в пункте выдачи: ' + _vm.freight.full_price.storage + ' р.'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "freight_seats_number",
      "id": "freight_seats_number",
      "label": "Количество мест",
      "type": "number",
      "required": "",
      "disabled": _vm.$props.block,
      "data-vv-as": " ",
      "error": _vm.errors.first('freight_seats_number'),
      "inline": ""
    },
    model: {
      value: (_vm.freight.seats_number),
      callback: function($$v) {
        _vm.$set(_vm.freight, "seats_number", $$v)
      },
      expression: "freight.seats_number"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0,
        max_value: 99999,
        decimal: [3, '.']
      }),
      expression: "{required: true, min_value: 0, max_value: 99999, decimal: [3, '.']}"
    }],
    attrs: {
      "name": "freight_weight",
      "id": "freight_weight",
      "label": "Вес (кг)",
      "type": "number",
      "required": "",
      "disabled": _vm.$props.block,
      "data-vv-as": " ",
      "error": _vm.errors.first('freight_weight'),
      "inline": ""
    },
    model: {
      value: (_vm.freight.weight),
      callback: function($$v) {
        _vm.$set(_vm.freight, "weight", $$v)
      },
      expression: "freight.weight"
    }
  }), _vm._v(" "), _c('z-check', {
    attrs: {
      "label": "Оформление ТТН",
      "id": "freight_ttn",
      "value": true,
      "error": _vm.errors.first('freight_ttn'),
      "data-vv-name": "freight_ttn",
      "data-vv-as": ' ',
      "disabled": true,
      "inline": ""
    },
    model: {
      value: (_vm.ttn),
      callback: function($$v) {
        _vm.ttn = $$v
      },
      expression: "ttn"
    }
  }), _vm._v(" "), _c('z-check', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight.weight > 0 && _vm.freight.size > 0),
      expression: "freight.weight > 0 && freight.size > 0"
    }],
    attrs: {
      "label": "Обрешётка",
      "id": "freight_doom",
      "value": 1,
      "disabled": _vm.$props.block,
      "error": _vm.errors.first('freight_doom'),
      "data-vv-name": "freight_doom",
      "data-vv-as": ' ',
      "inline": ""
    },
    model: {
      value: (_vm.freight.doom),
      callback: function($$v) {
        _vm.$set(_vm.freight, "doom", $$v)
      },
      expression: "freight.doom"
    }
  }), _vm._v(" "), (_vm.freight.extraservices && _vm.freight.extraservices.doom_make) ? _c('z-check', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight.weight > 0 && _vm.freight.size > 0),
      expression: "freight.weight > 0 && freight.size > 0"
    }],
    attrs: {
      "label": "Изготовление обрешётки",
      "id": "freight_doom_make",
      "value": 1,
      "error": _vm.errors.first('freight_doom_make'),
      "data-vv-name": "freight_doom_make",
      "data-vv-as": ' ',
      "disabled": true,
      "inline": ""
    },
    model: {
      value: (_vm.freight.extraservices.doom_make.value.value),
      callback: function($$v) {
        _vm.$set(_vm.freight.extraservices.doom_make.value, "value", $$v)
      },
      expression: "freight.extraservices.doom_make.value.value"
    }
  }) : _vm._e(), _vm._v(" "), _c('z-check', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight.weight > 0 && _vm.freight.size > 0),
      expression: "freight.weight > 0 && freight.size > 0"
    }],
    attrs: {
      "label": "Негабаритный груз",
      "id": "oversize",
      "value": 1,
      "error": _vm.errors.first('oversize'),
      "data-vv-name": "oversize",
      "data-vv-as": ' ',
      "disabled": _vm.$props.block || (!!_vm.freight.full_oversize),
      "inline": ""
    },
    model: {
      value: (_vm.freight.oversize),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize", $$v)
      },
      expression: "freight.oversize"
    }
  }), _vm._v(" "), ((_vm.fullOversizeMessage)) ? _c('div', {
    staticClass: "full_oversize error",
    domProps: {
      "innerHTML": _vm._s(_vm.fullOversizeMessage)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (!_vm.freight.size || _vm.freight.size < 0),
        min_value: (_vm.freight.size ? 0 : 0.001),
        max_value: 99999,
        decimal: [3, '.']
      }),
      expression: "{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 99999, decimal: [3, '.']}"
    }],
    attrs: {
      "name": "freight_height",
      "id": "freight_height",
      "label": "Высота (м)",
      "required": "",
      "type": "number",
      "disabled": _vm.$props.block,
      "data-vv-as": " ",
      "error": _vm.errors.first('freight_height'),
      "inline": ""
    },
    model: {
      value: (_vm.freight.height),
      callback: function($$v) {
        _vm.$set(_vm.freight, "height", $$v)
      },
      expression: "freight.height"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (!_vm.freight.size || _vm.freight.size < 0),
        min_value: (_vm.freight.size ? 0 : 0.001),
        max_value: 99999,
        decimal: [3, '.']
      }),
      expression: "{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 99999, decimal: [3, '.']}"
    }],
    attrs: {
      "name": "freight_length",
      "id": "freight_length",
      "label": "Длина (м)",
      "required": "",
      "type": "number",
      "disabled": _vm.$props.block,
      "data-vv-as": " ",
      "error": _vm.errors.first('freight_length'),
      "inline": ""
    },
    model: {
      value: (_vm.freight.length),
      callback: function($$v) {
        _vm.$set(_vm.freight, "length", $$v)
      },
      expression: "freight.length"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: (!_vm.freight.size || _vm.freight.size < 0),
        min_value: (_vm.freight.size ? 0 : 0.001),
        max_value: 99999,
        decimal: [3, '.']
      }),
      expression: "{required: (!freight.size || freight.size < 0), min_value: (freight.size ? 0 : 0.001), max_value: 99999, decimal: [3, '.']}"
    }],
    attrs: {
      "name": "freight_width",
      "id": "freight_width",
      "label": "Ширина (м)",
      "required": "",
      "type": "number",
      "disabled": _vm.$props.block,
      "data-vv-as": " ",
      "error": _vm.errors.first('freight_width'),
      "inline": ""
    },
    model: {
      value: (_vm.freight.width),
      callback: function($$v) {
        _vm.$set(_vm.freight, "width", $$v)
      },
      expression: "freight.width"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0.001,
        max_value: 99999,
        decimal: [3, '.']
      }),
      expression: "{required: true, min_value: 0.001, max_value: 99999, decimal: [3, '.']}"
    }],
    attrs: {
      "name": "freight_size",
      "id": "freight_size",
      "label": "Объем (м^3)",
      "required": "",
      "type": "number",
      "data-vv-as": " ",
      "disabled": (_vm.$props.block || (!!_vm.computedVolume && _vm.computedVolume > 0)),
      "error": _vm.errors.first('freight_size'),
      "inline": ""
    },
    model: {
      value: (_vm.freight.size),
      callback: function($$v) {
        _vm.$set(_vm.freight, "size", $$v)
      },
      expression: "freight.size"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(parseInt(_vm.freight.oversize) === 1) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !!_vm.freight.oversize,
        decimal: true,
        min_value: 0.001,
        max_value: ((!!_vm.freight.full_oversize) ? 9999999999 : (_vm.freight.weight ? parseFloat(_vm.freight.weight) : 0))
      }),
      expression: "{required: !!freight.oversize, decimal: true, min_value: 0.001, max_value: ((!!freight.full_oversize) ? 9999999999 : (freight.weight ? parseFloat(freight.weight) : 0))}"
    }],
    attrs: {
      "name": "oversize_weight",
      "id": "oversize_weight",
      "label": "Вес негабарита (кг)",
      "type": "number",
      "required": "",
      "data-vv-as": " ",
      "error": _vm.errors.first('oversize_weight'),
      "disabled": _vm.$props.block || (!!_vm.freight.full_oversize),
      "inline": ""
    },
    model: {
      value: (_vm.freight.oversize_weight),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_weight", $$v)
      },
      expression: "freight.oversize_weight"
    }
  }) : _vm._e(), _vm._v(" "), (parseInt(_vm.freight.oversize) === 1) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !!_vm.freight.oversize,
        decimal: true,
        min_value: 0.001,
        max_value: ((!!_vm.freight.full_oversize) ? 9999999999 : (_vm.freight.size ? parseFloat(_vm.freight.size) : 0))
      }),
      expression: "{required: !!freight.oversize, decimal: true, min_value: 0.001, max_value:  ((!!freight.full_oversize) ? 9999999999 : (freight.size ? parseFloat(freight.size) : 0))}"
    }],
    attrs: {
      "name": "oversize_size",
      "id": "oversize_size",
      "label": "Объем негабарита (м^3)",
      "type": "number",
      "required": "",
      "data-vv-as": " ",
      "error": _vm.errors.first('oversize_size'),
      "disabled": _vm.$props.block || (!!_vm.freight.full_oversize),
      "inline": ""
    },
    model: {
      value: (_vm.freight.oversize_size),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_size", $$v)
      },
      expression: "freight.oversize_size"
    }
  }) : _vm._e(), _vm._v(" "), ((parseInt(_vm.freight.oversize) ? true : false)) ? _c('z-input', {
    attrs: {
      "label": "Сумма сторон (м)",
      "required": true,
      "select-on-focus": true,
      "name": "freight_oversize_sum",
      "id": "freight_oversize_sum",
      "type": "number",
      "data-vv-name": "freight_oversize_sum",
      "data-vv-as": ' ',
      "disabled": true,
      "inline": ""
    },
    model: {
      value: (_vm.computedSumValue),
      callback: function($$v) {
        _vm.computedSumValue = $$v
      },
      expression: "computedSumValue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [((!_vm.hasDoom && parseInt(_vm.freight.oversize) && _vm.freight.height > 0 ? true : false)) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: ((!!_vm.freight.full_oversize) ? 9999999999 : (_vm.freight.height ? parseFloat(_vm.freight.height) : 0)),
        decimal: [3, '.']
      }),
      expression: "{required: false, min_value: 0, max_value: ((!!freight.full_oversize) ? 9999999999 : (freight.height ? parseFloat(freight.height) : 0)), decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Высота негабарита (м)",
      "select-on-focus": true,
      "name": "freight_oversize_height",
      "id": "freight_oversize_height",
      "error": _vm.errors.first('freight_oversize_height'),
      "data-vv-name": "freight_oversize_height",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": true,
      "inline": ""
    },
    model: {
      value: (_vm.freight.oversize_height),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_height", $$v)
      },
      expression: "freight.oversize_height"
    }
  }) : _vm._e(), _vm._v(" "), ((!_vm.hasDoom && parseInt(_vm.freight.oversize) && _vm.freight.length > 0 ? true : false)) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: ((!!_vm.freight.full_oversize) ? 9999999999 : (_vm.freight.length ? parseFloat(_vm.freight.length) : 0)),
        decimal: [3, '.']
      }),
      expression: "{required: false, min_value: 0, max_value: ((!!freight.full_oversize) ? 9999999999 : (freight.length ? parseFloat(freight.length) : 0)), decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Длина негабарита (м)",
      "select-on-focus": true,
      "name": "freight_oversize_length",
      "id": "freight_oversize_length",
      "error": _vm.errors.first('freight_oversize_length'),
      "data-vv-name": "freight_oversize_length",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": true,
      "inline": ""
    },
    model: {
      value: (_vm.freight.oversize_length),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_length", $$v)
      },
      expression: "freight.oversize_length"
    }
  }) : _vm._e(), _vm._v(" "), ((!_vm.hasDoom && parseInt(_vm.freight.oversize) && _vm.freight.width > 0 ? true : false)) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false,
        min_value: 0,
        max_value: ((!!_vm.freight.full_oversize) ? 9999999999 : (_vm.freight.width ? parseFloat(_vm.freight.width) : 0)),
        decimal: [3, '.']
      }),
      expression: "{required: false, min_value: 0, max_value: ((!!freight.full_oversize) ? 9999999999 : (freight.width ? parseFloat(freight.width) : 0)), decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Ширина негабарита (м)",
      "select-on-focus": true,
      "name": "freight_oversize_width",
      "id": "freight_oversize_width",
      "error": _vm.errors.first('freight_oversize_width'),
      "data-vv-name": "freight_oversize_width",
      "data-vv-as": ' ',
      "type": "number",
      "disabled": true,
      "inline": ""
    },
    model: {
      value: (_vm.freight.oversize_width),
      callback: function($$v) {
        _vm.$set(_vm.freight, "oversize_width", $$v)
      },
      expression: "freight.oversize_width"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-100"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:100'),
      expression: "'required|min:1|max:100'"
    }],
    attrs: {
      "name": "freight_description",
      "id": "freight_description",
      "label": "Наименование груза",
      "required": "",
      "disabled": _vm.$props.block,
      "data-vv-as": " ",
      "error": _vm.errors.first('freight_description')
    },
    model: {
      value: (_vm.freight.description),
      callback: function($$v) {
        _vm.$set(_vm.freight, "description", $$v)
      },
      expression: "freight.description"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51be0140","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/FreightCard.vue
// module id = 1137
// module chunks = 0